@import 'core';

:host {
  border-color: inherit;
  color: var(--ads-card-label-color, $ads-card-label-color);
  display: block;
  font-size: 20px;
  font-weight: 700;
  width: 100%;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .c-card-label {
    align-items: center;
    background-color: transparent;
    border-color: inherit;
    box-sizing: border-box;
    color: inherit;
    display: flex;
    flex-direction: row;
    font-family: var(--ads-font-family);
    font-size: inherit;
    font-weight: inherit;
    position: relative;
    width: 100%;


    // MODIFIERS

    .is-reversed {
      flex-direction: row-reverse;
    }

    // DESCENDANTS

    &__text {
      display: block;
      overflow: hidden;
      padding: 0 15px;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: auto;
    }

    &__border {
      align-self: baseline;
      border-color: inherit;
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-style: var(--ads-card-border-style, $ads-card-border-style);
      border-top-width: var(--ads-card-border-width, $ads-card-border-width);
      display: block;
      flex: 1 0 auto;
      margin-top: 15px;
      width: auto;
    }
  }
}
